var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "button-common" }, [
    _c(
      "button",
      {
        class: [_vm.type],
        style: {
          height: _vm.height,
          width: _vm.width,
        },
        attrs: { disabled: _vm.disabled },
        on: { click: _vm.handle },
      },
      [
        _vm.loading
          ? _c(
              "svg",
              {
                attrs: { width: "24px", height: "24px", viewBox: "0 0 24 24" },
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "body/loading",
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd",
                    },
                  },
                  [
                    _c(
                      "g",
                      { attrs: { id: "icons/body/loading" } },
                      [
                        _c("circle", {
                          attrs: {
                            id: "椭圆形",
                            stroke: "#000",
                            "stroke-width": "3",
                            cx: "12",
                            cy: "12",
                            r: "10.5",
                          },
                        }),
                        _c("circle", {
                          attrs: {
                            id: "椭圆形",
                            fill: "#0552DC",
                            cx: "12",
                            cy: "6",
                            r: "3",
                          },
                        }),
                        _c("animateTransform", {
                          attrs: {
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            dur: "1s",
                            from: "0 12 12",
                            to: "360 12 12",
                            repeatCount: "indefinite",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            )
          : _vm._t("default"),
        _c(
          "div",
          { staticClass: "c-button-ripple" },
          _vm._l(_vm.ripple, function (item) {
            return _c("div", {
              key: item,
              staticClass: "c-button-ripple-item",
              style: { left: _vm.rippleX + "px", top: _vm.rippleY + "px" },
            })
          }),
          0
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }